<template>
  <div>
    <div class="row justify-content-end align-items-end mb-3">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-sm btn-outline-secondary">
          <i class="bi bi-arrow-clockwise me-1"></i>
          Actualiser
        </button>
      </div>
    </div>

    <vue-data-table  :headers="headers" :data="checks" :items-per-page="10" :buttons="buttons">
      <!-- Status Column with conditional coloring -->
      <template #cell-status="{ row }">
        <span :class="{
          'badge bg-success': row.status == 'paid' || row.status == 'Payé',
          'badge bg-warning': row.status == 'Chèque en attente' || row.status == 'pending',
          'badge bg-danger': row.status == 'rejected' || row.status == 'Rejeté',
          'badge bg-info': row.status == 'deposited' || row.status == 'Déposé',
          'badge bg-secondary': !row.status || row.status == 'unknown'
        }">
          {{ row.status || 'N/A' }}
        </span>
      </template>

      <!-- Amount Column -->
      <template #cell-amount="{ row }">
        <span class="fw-bold text-end d-block" :class="{
          'text-success': row.amount > 0,
          'text-danger': row.amount < 0
        }">
          {{ formatCurrency(row.amount) }}
        </span>
      </template>

      <template #cell-inTransaction="{ row }">
        <span :class="{
          'badge bg-success': row.inTransaction == true,
          'badge bg-danger': row.inTransaction == false
        }">
          {{ row.inTransaction ? 'Versé' : 'Non versé' }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence" },
        { field: "checkNumber", label: "Nº Chéque" },
        { field: "bank", label: "Banque" },
        { field: "customerFullName", label: "Client" },
        { field: "fullName", label: "Sous Client" },
        { field: "status", label: "Etat" },
        { field: "date", label: "Date" },
        { field: "deadline", label: "Date échéance" },
        { field: "amount", label: "Montant" },
        { field: "inTransaction", label: "Versement" },
        { field: "remark", label: "NB" },
        { field: "userFullName", label: "Créé par" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn btn-sm btn-outline-primary",
          action: (check) => {
            this.$router.push({
              name: "checks-customers-details",
              params: { reference: check.reference },
            });
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("check", {
      checks: "getChecks",
    }),
  },
  mounted() {
    this.$store.dispatch("check/getAll");
  },
  methods: {
    formatCurrency(value) {
      if (isNaN(value) || value === null || value === undefined) return 'N/A';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'MAD'
      }).format(Math.abs(value));
    },
    async refresh() {
       await this.$store.dispatch("check/getAll");
    }
  },
};
</script>